import { render, staticRenderFns } from "./BlurredPricingCurveBenefitsComponent.vue?vue&type=template&id=899bb916"
import script from "./BlurredPricingCurveBenefitsComponent.vue?vue&type=script&lang=ts"
export * from "./BlurredPricingCurveBenefitsComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports